<div class="w-full">
	@for (comment of comments; track comment; let commentId = $index) {
		<div
			class="flex-start flex max-w-full items-start gap-4 border-b border-blue-20 py-3 first:border-t"
			[style.lineHeight]="1.5"
		>
			<div class="min-w-52 pt-2">
				<div class="text-sm">
					{{ comment?.maneuver }}
				</div>
				<div>
					@if (!editable[commentId]) {
						<span>
							@if (comment.candidateRole === CANDIDATE_ROLE.PF) {
								[ <span class="text-purple-90">PF</span> ]
							}
							@if (comment.candidateRole === CANDIDATE_ROLE.PM) {
								[ <span class="text-purple-90">PM</span> ]
							}
						</span>
					}

					@if (editable[commentId] && comment.candidateRole != CANDIDATE_ROLE.NONE) {
						<div>
							<span class="mr-1">PF</span>
							<mat-slide-toggle
								[checked]="getToggleValue(commentId)"
								(change)="onToggleChange(commentId, $event.checked)"
								>&nbsp;
							</mat-slide-toggle>
							<span>PM</span>
						</div>
					}
				</div>
			</div>
			@if (comment?.ob === "REPEAT") {
				<div class="min-w-32 pt-2 text-yellow">
					{{ comment?.ob }}
				</div>
			}
			@if (comment?.ob !== "TEM" && comment?.ob !== "REPEAT") {
				<div class="min-w-32 pt-2" [class.text-green]="comment?.action" [class.text-red]="!comment?.action">
					{{ comment?.ob }} {{ comment?.action ? "[ Added ]" : "[ Removed ]" }}
				</div>
			}
			@if (comment?.ob === "TEM") {
				<div
					class="min-w-32 pt-2"
					[class.text-green]="(comment?.rate ?? 0) > 1"
					[class.text-red]="(comment?.rate ?? 0) <= 1"
					[class.text-yellow]="(comment?.rate ?? 0) === -1"
				>
					TEM {{ "[ " + comment?.remarks + " ]" }}
				</div>
			}
			<div class="flex-1 pt-2">
				<div class="w-full whitespace-pre-wrap pb-2" [style.lineHeight]="1.5">
					@if (!editable[commentId]) {
						<div class="break-all">
							{{ comment?.instructorComment }}
						</div>
					}
					@if (editable[commentId]) {
						<div>
							<textarea
								[formControl]="addObComments"
								class="border-bg-grey-20 h-[160px] w-full border p-4"
								maxlength="500"
							>
							</textarea>
							<p class="text-right">
								<span class="text-grey-90 text-[10px]">({{ addObComments.value.length + " / 500" }})</span>
							</p>
						</div>
					}
				</div>
			</div>
			<div class="w-6">
				<button class="flex size-6 rounded-sm text-center">
					@if (!editable[commentId]) {
						<mat-icon class="text-xl text-purple-90" (click)="editComment(comment, commentId)">edit</mat-icon>
					}
					@if (editable[commentId]) {
						<mat-icon class="text-xl text-purple-90" (click)="saveComment(comment, commentId)">save</mat-icon>
					}
				</button>
			</div>
		</div>
	}

	@for (comment of instructorComments; track comment; let instructorCommentsId = $index) {
		<div
			class="flex-start flex max-w-full items-start gap-4 border-b border-blue-20 py-3 first:border-t"
			[style.lineHeight]="1.5"
		>
			<div class="min-w-52 pt-2">
				<div class="text-sm">
					{{ comment?.maneuver }}
				</div>
				<!-- <div>
                      [<span class="text-purple-90">PF</span>]
                    </div> -->
			</div>
			<!-- <div class="flex-1 pt-2">
                  <div class="w-full whitespace-pre-wrap pb-2" [style.lineHeight]="1.5">
                    {{ comment?.comment }}
                  </div>
                </div> -->
			<div class="flex-1 pt-2">
				<div class="w-full whitespace-pre-wrap pb-2" [style.lineHeight]="1.5">
					@if (!editable[instructorCommentsId]) {
						<div class="break-all">
							{{ comment?.comment }}
						</div>
					}
					@if (editable[instructorCommentsId]) {
						<div>
							<textarea
								[formControl]="otherInstructorComments"
								class="border-bg-grey-20 h-[160px] w-full border p-4"
								maxlength="500"
							>
							</textarea>
							<p class="text-right">
								<span class="text-grey-90 text-[10px]">({{ otherInstructorComments.value.length + " / 500" }})</span>
							</p>
						</div>
					}
				</div>
			</div>
			<div class="w-6">
				<button class="flex size-6 rounded-sm text-center">
					@if (!editable[instructorCommentsId]) {
						<mat-icon class="text-xl text-purple-90" (click)="editInstructorComment(comment, instructorCommentsId)"
							>edit</mat-icon
						>
					}
					@if (editable[instructorCommentsId]) {
						<mat-icon class="text-xl text-purple-90" (click)="saveInstructorComment(comment, instructorCommentsId)"
							>save</mat-icon
						>
					}
				</button>
			</div>
		</div>
	}
</div>
